import React from 'react';
import { IMG_INTERIOR } from '../../utils/constants';
export function InsideGallery() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-173" data-mp="1wfba51w1mfty">
      <div className="max-w-6xl mx-auto" data-id="element-174" data-mp="1wdryxpp8uuz1">
        <div className="text-center max-w-3xl mx-auto" data-id="element-175" data-mp="21enzbtadzyzp">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-176" data-mp="21cutuhbifkta">
            Así es por dentro
          </h2>
          <p className="mt-4 text-lg text-tinta/75" data-id="element-177" data-mp="2b5imczvgj2m7">
            Fichas para imprimir y páginas de método: no son solo renglones para rellenar.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6" data-id="element-178" data-mp="2k5fghh0m8ton">
          {IMG_INTERIOR.map(item => <figure key={item.src} className="flex flex-col" data-id="element-179" data-mp="2p51tbpcj87wx">
              <img src={item.src} alt={item.caption} loading="lazy" className="w-full rounded-2xl shadow-xl border border-black/5 bg-white" data-id="element-180" data-mp="2p25vs24ljl90" />
              <figcaption className="mt-3 text-xs sm:text-sm text-tinta/70 leading-snug" data-id="element-181" data-mp="7gj1j911kstv">
                {item.caption}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}